import { Autocomplete, Box, Stack, TextField, Toolbar as MuiToolbar, Button } from '@mui/material';
import { useState } from 'react';
import { COURSE_STATUS } from 'src/helpers';
import { getCategoryList } from 'src/services';

export const Toolbar = ({ name, query, setQuery, onRefresh }) => {
  const [open, setOpen] = useState({
    category: false,
  });

  const [categoryList, setCategoryList] = useState([]);

  const [loading, setLoading] = useState({
    category: false,
  });

  const getCategory = async () => {
    setLoading({ ...loading, category: true });
    try {
      const response = await getCategoryList();
      const arr = response.categories;
      const key = 'name';
      const arrayUniqueByKey = [...new Map(arr.map((item) => [item[key], item])).values()];
      setLoading({ ...loading, category: true });
      setCategoryList(arrayUniqueByKey);
    } catch (error) {
      console.log(error);
      setLoading({ ...loading, category: true });
    }
  };
  return (
    <MuiToolbar sx={{ my: 1 }}>
      <Stack display="flex" flexDirection="row" sx={{ flex: 1 }}>
        <TextField
          value={query.title}
          onChange={(e) => setQuery({ ...query, title: e.target.value })}
          placeholder="جستجو"
          sx={{ mx: 1 }}
          autoComplete="off"
        />
        {query.status && (
          <Autocomplete
            disableClearable
            options={findOptions(name)}
            getOptionLabel={(option) => option.label || ''}
            value={query.status}
            onChange={(e, newValue) => {
              setQuery({ ...query, status: newValue });
            }}
            renderInput={(params) => <TextField {...params} sx={{ mx: 1, width: 200 }} label="فیلتر" />}
          />
        )}

        {['course'].includes(name) && (
          <Autocomplete
            options={categoryList}
            getOptionLabel={(option) => option?.name || ''}
            open={open.category}
            onOpen={() => {
              setOpen({ ...open, category: true });
              getCategory();
            }}
            onClose={() => setOpen({ ...open, category: false })}
            loading={loading.category}
            value={query.category}
            onChange={(e, newValue) => {
              setQuery({ ...query, category: newValue });
            }}
            renderInput={(params) => <TextField {...params} sx={{ mx: 1, width: 200 }} label="دسته بندی" />}
          />
        )}

        <Box sx={{ flexGrow: 1 }} />

        {onRefresh && (
          <Button variant="contained" onClick={onRefresh}>
            بروزرسانی لیست امتیازات
          </Button>
        )}
      </Stack>
    </MuiToolbar>
  );
};

const findOptions = (name) => {
  switch (name) {
    case 'course':
      return COURSE_STATUS;

    default:
      break;
  }
};
